import brand from '@helpers/brand';
import { Device, from, until } from '@helpers/media';
import styled, { css } from 'styled-components';
import { ReactComponent as SvgChevron } from '@img/icons/chevron-down.svg';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import animation from '@helpers/animation';
const Chevron = styled(SvgChevron) `
  width: 14px;
  margin-left: 10px;
`;
const LinkText = styled.span ``;
const LinkInternal = styled.div `
  display: inline-flex;
  position: relative;

  &:after {
      content: '';
      display: block;
      position: absolute;
      bottom: 2px;
      width: 100%;
      height: 1px;
      background-color: ${cssVar('fgColor')};
      transition: transform 0.3s, background-color 0.3s;
      transition-timing-function: ${animation.secondary};
      transform: scaleX(0);

      @media (prefers-reduced-motion: reduce)  {
        transition: background-color 0.3s;
      }
    }
`;
const Link = styled.a `
  ${fonts.matter.medium};
  position: relative;
  display: block;  
  color: ${cssVar('fgColor')};
  font-size: 22px;
  line-height: 32px;
  margin: 0;
  padding: 20px 22px;
  text-decoration: none;
  transition: background-color 0.15s ease-out, background-size 0.15s ease-out, color 0.15s ease-out;

  

  &:focus,
  &:hover {
    text-decoration: none;

    ${LinkInternal} {
      &:after {
        transform: scaleX(1);
      }
    }    
  }

  &:focus {
    outline: none;
  }

  ${({ isActive }) => isActive &&
    css `
      text-decoration: none;

      ${LinkInternal} {
        &:after {
          transform: scaleX(1);
        }
      }  
    `}

  ${({ centered }) => centered &&
    css `
      text-align: center;
    `}

  /* @media ${until(Device.TabletLarge)} {
    background: ${cssVar('bgColor')};
    padding-left: 10px;
    padding-right: 10px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 15px;
    padding: 17px 11px 17px;
  } */

  @media ${from(Device.DesktopSmall)} {
    font-size: 18px;
    padding: 15px 8px;
  }

  @media ${from(Device.Desktop)} {
    font-size: 20px;
    padding: 20px 10px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 22px;
    padding: 20px 22px;
  }

`;
const Item = styled.li `
  ${setCssVar('accentColor', brand.sage.sageDark)};
  ${setCssVar('bgColor', brand.grey.greyLight)};
  ${setCssVar('fgColor', brand.black)};
  ${setCssVar('fgColorAlt', brand.black)};

  &:first-child {
    ${Link} {
      padding-left: 0;
    }
  }


  display: block;
  margin: 0;
  padding: 0;
  cursor: pointer;

  @media ${until(Device.TabletLarge)} {
    margin-bottom: 3px;
  }
`;
export default {
    Chevron,
    Item,
    Link,
    LinkInternal,
    LinkText,
};
